const styles = theme => ({
  publicBlockGeneral : theme.showHtmlText,
});

export default styles;